'use strict';

import React from 'react';
import { toast } from 'react-hot-toast';
import _ from 'underscore';

type Message = {
  message: string;
  color: MessageColor;
};

export enum MessageColor {
  RED = 'red',
  GREEN = 'green',
}

let subscriptions = [];
function subscribe(callback) {
  subscriptions.push(callback);
  //console.log('[StatusBar] Component subscribed.');
}

function unsubscribe(callback) {
  subscriptions = _.without(subscriptions, callback);
  //console.log('[StatusBar] Component unsubscribed.');
}

function sendErrorMessage(message) {
  toast.error(message);
}

// eslint-disable-next-line @typescript-eslint/ban-types
class StatusBar extends React.Component<{}, { messages: Message[] }> {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
    };
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.push = this.push.bind(this);
    this.dismissLastMessage = this.dismissLastMessage.bind(this);
    this.dismissAllMessages = this.dismissAllMessages.bind(this);
    subscribe(this.push);
  }
  componentWillUnmount() {
    //console.log('[StatusBar] Component will unmount.');
    unsubscribe(this.push);
  }
  push(message, color) {
    const messages = this.state.messages;
    messages.push({ message, color });
    this.setState({ messages });
  }
  dismissLastMessage() {
    const messages = this.state.messages;
    messages.pop();
    this.setState({ messages });
  }
  dismissAllMessages() {
    this.setState({ messages: [] });
  }
  render() {
    const lastMessage: Message | undefined =
      this.state.messages[this.state.messages.length - 1];
    const statusBarClass =
      this.state.messages && this.state.messages.length > 0
        ? 'status-bar open'
        : 'status-bar';

    return (
      <div className={statusBarClass + ' ' + lastMessage?.color}>
        <p>{lastMessage?.message}</p>
        {this.state.messages.length > 1 && (
          <a onClick={this.dismissAllMessages} className="actionLink button">
            Dismiss all messages ({this.state.messages.length})
            <span className="icon-remove"></span>
          </a>
        )}
        <a onClick={this.dismissLastMessage} className="actionLink button">
          Dismiss <span className="icon-remove"></span>
        </a>
      </div>
    );
  }
}

export default { Component: StatusBar, sendErrorMessage: sendErrorMessage };
